/** Retired gears with solid capped hubs instead of face-like clusters of dark holes. */
import { checkEnvelope, checkScope, el, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, gear, grainRng, ground, line } from './machinerySvg';
export interface GearHeapParams { readonly gears: number; readonly rust: number }
export type GearHeapRecipe = PieceRecipe<'mill.gear_heap.v1', GearHeapParams>;
export const GEAR_HEAP_FRAME = { w: 120, h: 80 } as const;
export const MILL_GEAR_HEAP: GearHeapRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.gear_heap.default.v1', generatorId: 'mill.gear_heap.v1',
  seed: 20071006, paletteId: 'millrace_amber', params: { gears: 4, rust: 0.6 },
};
export function buildGearHeap(recipe: GearHeapRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_GEAR_HEAP.generatorId); checkScope(scope);
  const gears = amount(recipe.params.gears, 'gears', 2, 5, true), rust = amount(recipe.params.rust, 'rust');
  const random = grainRng(recipe), parts: string[] = [];
  const positions = [{ x: 40, y: 43, r: 29 }, { x: 84, y: 54, r: 22 }, { x: 77, y: 29, r: 18 }, { x: 21, y: 61, r: 14 }, { x: 59, y: 64, r: 12 }];
  let metal = '';
  // Back-to-front order, retaining the large read of the oldest drive wheel.
  for (const i of [2, 0, 1, 3, 4].filter(index => index < gears)) {
    const { x, y, r } = positions[i];
    metal += gear(x, y, r, 10 + i, p, rust);
    for (let j = 0; j < 6; j++) {
      const angle = random(`pit.${i}.${j}`) * Math.PI * 2, distance = r * (0.4 + random(`rad.${i}.${j}`) * 0.33);
      metal += el('circle', { cx: x + Math.cos(angle) * distance, cy: y + Math.sin(angle) * distance, r: 0.5 + rust * 1.2, fill: p.paperShadow, opacity: 0.75 });
    }
    metal += line(x - r * 0.45, y - r * 0.4, x - r * 0.1, y - r * 0.58, p.stoneLight, 1.1);
  }
  const body = partGroup(parts, 'gear-ground', ground(120, 80, p)) + partGroup(parts, 'gear-castings', metal);
  return { frame: GEAR_HEAP_FRAME, body, anchors: { support: { x: 60, y: 80 } }, parts, openings: [] };
}
